import { Box } from '@talos/kyoko';
import styled from 'styled-components';

export const DealProductBuilderWrapper = styled(Box)`
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
  background: ${({ theme }) => theme.backgroundContent};

  // TODO: this is good-enough for dynamic cell edit styling,but could be stronger
  .ag-row {
    .ag-cell.ag-cell-editable {
      width: 100%;
      height: 25px;
      display: flex;
      margin-top: ${({ theme }) => theme.spacing4}px;
      border-radius: ${({ theme }) => theme.borderRadiusDefault}px;

      .ag-cell-value-container {
        height: 100%;
        display: flex;
        padding: 0 ${({ theme }) => theme.spacing4}px;
        align-items: center;
        background: ${({ theme }) => theme.colors.gray['030']};
        width: calc(100% - 10px);

        & > span {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
`;
